import { toast } from 'sonner';

export function prototypeNavigate(label: string, url: string): void {
  toast(label, { description: `Prototype link → ${url}` });
}
